"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var config_1 = require("../config/config");
var cart_service_1 = require("../services/cart.service");
var free_gifts_service_1 = require("../services/free-gifts.service");
var store_checkout_selectors_1 = require("./checkout/store-checkout-selectors");
var store_account_selectors_1 = require("./account/store-account-selectors");
var store_checkout_translations_1 = require("./checkout/store-checkout-translations");
var Store = /** @class */ (function () {
    function Store() {
        this.cartService = new cart_service_1["default"]();
        window[config_1["default"].storeKey] = {
            commonApiUrl: config_1["default"].apiUrl,
            shopUrl: 'https://www.chantecaille.com.hk',
            serverErrorMessage: 'Something went wrong',
            selectors: {
                body: 'body',
                continueBtn: '#continue_button',
                isLoggedInCustomerInput: '#is_logged_in_customer',
                account: store_account_selectors_1["default"],
                checkout: store_checkout_selectors_1.checkoutSelectors
            },
            translations: {
                checkout: store_checkout_translations_1["default"]
            },
            localstorageKeys: {
                utm: 'chante-hk-utm'
            },
            sessionStorageKeys: {
                phoneField1Name: 'chante-hk-phone-field1',
                phoneField2Name: 'chante-hk-phone-field2',
            },
            cart: window['Shopify'].cart ? JSON.parse(JSON.stringify(window['Shopify'].cart)) : null
        };
    }
    Store.prototype.fetchAsyncStates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!window[config_1["default"].storeKey].cart) return [3 /*break*/, 2];
                        _a = window[config_1["default"].storeKey];
                        return [4 /*yield*/, this.cartService.get()];
                    case 1:
                        _a.cart = _d.sent();
                        _d.label = 2;
                    case 2:
                        this.freeGiftsService = new free_gifts_service_1["default"]();
                        if (!!window[config_1["default"].storeKey].thresholds) return [3 /*break*/, 4];
                        _b = window[config_1["default"].storeKey];
                        return [4 /*yield*/, this.freeGiftsService.getThresholds()];
                    case 3:
                        _b.thresholds = _d.sent();
                        _d.label = 4;
                    case 4:
                        if (!!window[config_1["default"].storeKey].currentThreshold) return [3 /*break*/, 6];
                        _c = window[config_1["default"].storeKey];
                        return [4 /*yield*/, this.freeGiftsService.getQualifiedThreshold()];
                    case 5:
                        _c.currentThreshold = _d.sent();
                        _d.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return Store;
}());
exports["default"] = Store;
